import { defineComponent } from 'vue';
import { appPort, jumpModuleApp } from '@/widget/index';
export default defineComponent({
    props: {
        size: {
            type: String,
            default: 'normal'
        },
        item: {
            type: Object,
            default() {
                return {};
            }
        },
        isBuy: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toDetail(item) {
            if (!item.isStarted) {
                this.$toast('内容正在筹备中，敬请期待');
                return;
            }
            if (item.free || this.isBuy) {
                if (appPort()) {
                    jumpModuleApp({
                        typeId: 'exercise_home',
                        dataId: item.id,
                        type: 'INDIVIDUAL'
                    });
                }
                else {
                    // h5 进入导览页
                    this.$router.push({
                        path: "/guide/exercise",
                        query: {
                            id: item.id
                        }
                    });
                }
            }
            else {
                // 未购买不免费练习进入导览页
                if (appPort()) {
                    jumpModuleApp({
                        typeId: 'smart_exercise_detail',
                        dataId: item.id
                    });
                }
                else {
                    this.$router.push({
                        path: "/guide/exercise",
                        query: {
                            id: item.id
                        }
                    });
                }
            }
        }
    }
});
